<script lang="ts" context="module">
  export type OfferComponentType = 'freeGiftDataList' | 'couponData' | 'bankPromotionDetails';
</script>

<script lang="ts">
  import { formatNumber, getStr, globalCurrencyTag } from '../../../common/util';
  import CouponContainer from './CouponContainer.svelte';
  import FreegiftLabel from './FreegiftLabel.svelte';
  import PdpSectionAccordionCard from './PDPSectionAccordionCard.svelte';
  import ProductBankPromotion from './ProductBankPromotion.svelte';

  export let data: any;
  export let preorder: boolean = false;

  const componentOrder: OfferComponentType[] = ['freeGiftDataList', 'couponData', 'bankPromotionDetails'];

  $: visible = getComponentVisibility(data, componentOrder);
  $: freeGiftSummary = getFreeGiftSummary(data?.freeGiftDataList);
  $: bankDealCount = Array.isArray(data?.bankPromotionDetails) ? data.bankPromotionDetails.length : 0;
  $: bankDealsSummary = bankDealCount > 0 ? getStr('extra.pdp.deals.available.message', [bankDealCount]) : '';

  function getComponentVisibility(data: any, componentOrder: OfferComponentType[]) {
    return componentOrder.some(p => p in data && data[p] !== null);
  }

  function getFreeGiftSummary(freeGiftDataList: any) {
    if (!Array.isArray(freeGiftDataList) || freeGiftDataList.length === 0) return '';
    const firstGroup = freeGiftDataList[0];
    const qty = firstGroup?.freeGiftQtuantities?.sourceQty;
    const worth = firstGroup?.freeGiftWorth;
    if (!qty || !worth) return '';
    return getStr('extra.pdp.free.gift.worth.message', [
      qty,
      globalCurrencyTag,
      `<strong>${formatNumber(worth)}</strong>`,
    ]);
  }
</script>

{#if visible}
  {#if data?.couponData}
    <PdpSectionAccordionCard titleKey="extra.pdp.offer" icon="icon-gift_card" initiallyExpanded={false}>
      <section class="offer-card-component offer-couponData">
        <CouponContainer couponData={data.couponData} />
      </section>
    </PdpSectionAccordionCard>
  {/if}
  {#if data?.freeGiftDataList && !preorder}
    <PdpSectionAccordionCard
      titleKey="extra.pdp.free.gifts.message"
      icon="gift"
      iconType="png"
      initiallyExpanded={false}
    >
      <span slot="header-right" class="freegift-summary">{@html freeGiftSummary}</span>
      <FreegiftLabel freeGiftDataList={data.freeGiftDataList} />
    </PdpSectionAccordionCard>
  {/if}

  {#if data?.bankPromotionDetails}
    <PdpSectionAccordionCard titleKey="extra.pdp.offer" icon="icon-gift_card" initiallyExpanded={false}>
      <span slot="header-right" class="bankpromotion-summary">{bankDealsSummary}</span>
      <ProductBankPromotion bankPromotionDetails={data.bankPromotionDetails} />
    </PdpSectionAccordionCard>
  {/if}
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .offer-card-component {
    display: flex;
    flex-direction: column;
    padding: 8px 10px;
    border-radius: 8px;
    background-color: $primary-white;
  }

  :global(.freegift-summary) {
    color: $neutral-dark-02;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    white-space: nowrap;
  }
  :global(.freegift-summary strong) {
    color: $neutral-dark-02;
    font-weight: 700;
    font-size: 20px;
    line-height: 18px;
  }

  :global(.bankpromotion-summary) {
    color: $neutral-dark-02;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    white-space: nowrap;
  }
</style>
